<template>
  <div id="app">
    <app-header />
    <router-view></router-view>
  </div>
</template>

<script>
  import AppHeader from '@/components/AppHeader'
  import AppFooter from '@/components/AppFooter'

  export default {
    name: 'app',
    components: {
      AppHeader,
      AppFooter
    }
  }
</script>

<!-- <style src="bootstrap/dist/css/bootstrap.css"></style>
<style src="bootstrap/dist/css/bootstrap-theme.css"></style> -->
<style lang="sass">
  body
    background: #222
  #app
    // opacity: .5
    font-family: 'Open Sans', sans-serif
    // height: 5000px
    // background:  url(assets/pages/Webo.png) no-repeat top center
    // background-size: cover
  *:focus
    outline: none

  #footer
    padding: 0 !important

  ul
    padding-left: 20px

  .toast
    opacity: 1 !important
</style>



// WEBPACK FOOTER //
// App.vue?36ada564